import { StopOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { useSnackbar } from 'notistack';
import UserService from 'services/nostradamus/administration/UserService';

export const toggleEnabledAction = () => {
    return props => {
        const { component: MenuItem, onClick, params, ...restProps } = props;

        const { id, row } = params;
        const isEnabled = row?.enabled !== false;
        const value = 'toggle_enabled';
        const label = isEnabled ? 'Disable' : 'Enable';
        const Icon = isEnabled ? StopOutlined : CheckCircleOutlined;

        const { enqueueSnackbar } = useSnackbar();

        const handleToggle = async () => {
            try {
                await UserService.toggleEnabled(id);
                enqueueSnackbar(
                    `User ${row?.email || ''} ${isEnabled ? 'disabled' : 'enabled'}`,
                    { variant: 'success' },
                );
                onClick(value);
            } catch (err) {
                const msg =
                    err?.response?.data?.message || 'Failed to update user status';
                enqueueSnackbar(msg, { variant: 'error' });
            }
        };

        return (
            <MenuItem
                key={value}
                value={value}
                label={label}
                icon={<Icon />}
                onClick={handleToggle}
                {...restProps}
            >
                {label}
            </MenuItem>
        );
    };
};
